import { fetchMetricData, fetchMetricsData } from "./actions/fetchActions";
import {
  metricsReducer,
  metricReducer,
  createMetricReducer,
  updateMetricReducer,
  deleteMetricReducer,
} from "./reducers/fetchReducers";

const metricsReducers = {
  metricsGlobalStore: metricsReducer,
  metricGlobalStore: metricReducer,
  createMetricGlobalStore: createMetricReducer,
  updateMetricGlobalStore: updateMetricReducer,
  deleteMetricGlobalStore: deleteMetricReducer,
};

export { fetchMetricData, fetchMetricsData, metricsReducers };
